package es.cragma.fichajefacil.ui.screens.auth

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import es.cragma.fichajefacil.model.Company
import es.cragma.fichajefacil.model.User
import es.cragma.fichajefacil.ui.components.CragmaHeader
import es.cragma.fichajefacil.ui.components.StyledButtonPrimary
import es.cragma.fichajefacil.ui.i18n.AppLanguage
import es.cragma.fichajefacil.ui.i18n.LocalizedStrings
import es.cragma.fichajefacil.ui.theme.*

@Composable
fun TerminatedAccountScreen(
    user: User,
    company: Company?,
    currentLanguage: AppLanguage = AppLanguage.SPANISH,
    onBackToLogin: () -> Unit
) {
    val s = remember(currentLanguage) { LocalizedStrings.get(currentLanguage) }
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(CragmaBgLight)
            .windowInsetsPadding(WindowInsets.safeDrawing)
            .padding(24.dp),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .widthIn(max = 500.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            CragmaHeader()

            Spacer(modifier = Modifier.height(28.dp))

            Card(
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(24.dp),
                colors = CardDefaults.cardColors(containerColor = Color.White),
                elevation = CardDefaults.cardElevation(defaultElevation = 6.dp)
            ) {
                Column(
                    modifier = Modifier.padding(28.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Box(
                        modifier = Modifier
                            .size(64.dp)
                            .background(Color(0xFFFEE2E2), RoundedCornerShape(32.dp)),
                        contentAlignment = Alignment.Center
                    ) {
                        Text("🚫", fontSize = 32.sp)
                    }

                    Spacer(modifier = Modifier.height(16.dp))

                    Text(
                        text = "Usuario Dado de Baja",
                        fontSize = 20.sp,
                        fontWeight = FontWeight.Bold,
                        color = CragmaRedDanger
                    )

                    Spacer(modifier = Modifier.height(8.dp))

                    Text(
                        text = "Estimado/a ${user.name}:",
                        fontSize = 14.sp,
                        fontWeight = FontWeight.SemiBold,
                        color = CragmaNavyDark
                    )

                    Spacer(modifier = Modifier.height(6.dp))

                    Text(
                        text = "Tu cuenta de usuario en ${company?.name ?: "tu empresa"} consta actualmente como dada de baja en la plataforma y el acceso ha sido desactivado.",
                        fontSize = 13.sp,
                        color = CragmaTextSecondary,
                        textAlign = TextAlign.Center,
                        lineHeight = 18.sp
                    )

                    Spacer(modifier = Modifier.height(16.dp))

                    Surface(
                        color = Color(0xFFF8FAFC),
                        shape = RoundedCornerShape(12.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Column(
                            modifier = Modifier.padding(14.dp)
                        ) {
                            Text(
                                text = "ℹ Informes y Certificados:",
                                fontSize = 12.sp,
                                fontWeight = FontWeight.Bold,
                                color = CragmaNavyDark
                            )
                            Spacer(modifier = Modifier.height(4.dp))
                            Text(
                                text = "Si necesitas solicitar tus certificados de retenciones, histórico de registro de jornada o documentación de finiquito, ponte en contacto directo con el departamento de Recursos Humanos de la empresa.",
                                fontSize = 11.sp,
                                color = CragmaTextSecondary,
                                lineHeight = 15.sp
                            )
                        }
                    }

                    Spacer(modifier = Modifier.height(24.dp))

                    StyledButtonPrimary(
                        text = "Volver al Inicio de Sesión",
                        onClick = onBackToLogin
                    )
                }
            }
        }
    }
}
